"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconRearCrossTrafficWarning = function IconRearCrossTrafficWarning(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "30",
    height: "30",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.08486 13.42L6.25486 11.46C1.91486 17.73 0.814862 25.76 3.32486 32.94C4.14486 35.31 5.33486 37.53 6.85486 39.53L9.60486 37.45C8.30486 35.74 7.29486 33.84 6.58486 31.81C4.43486 25.66 5.36486 18.79 9.08486 13.42Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.5948 30.39C10.9248 25.58 11.6548 20.2 14.5648 16L11.7348 14.04C8.19484 19.14 7.30484 25.68 9.33484 31.53C10.0148 33.48 10.9848 35.28 12.2148 36.9L14.9548 34.81C13.9548 33.48 13.1548 31.99 12.5948 30.39Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.9648 37.27H43.1948C42.9648 37.27 42.7348 35.58 42.9648 35.51H47.4548C47.6248 35.51 47.7948 35.52 47.9548 35.55V15.1C47.7548 15.13 47.5448 15.14 47.3348 15.14H42.9548C42.7248 15.08 42.9648 13.38 43.1848 13.38H47.6148H47.9548V11H47.6148H26.2948C22.2648 11 18.8248 13.5 17.4248 17.03C17.4248 17.03 14.1448 24.95 17.4248 33.63C18.8248 37.16 22.2648 39.66 26.2948 39.66H47.6248H47.9648V37.27ZM40.8148 13.38V15.14C40.8148 15.14 38.1648 15.33 33.8648 14.89C33.1548 14.82 28.7048 13.38 28.7048 13.38H40.8148ZM26.5848 35.64C25.6048 32.55 25.0548 29.04 25.0548 25.33C25.0548 21.62 25.6048 18.11 26.5848 15.02C26.6648 14.76 26.8548 14.62 27.0348 14.68L32.5148 16.46C32.7448 16.53 32.8848 16.89 32.8048 17.24C32.2148 19.76 31.8948 22.48 31.8948 25.33C31.8948 28.18 32.2248 30.91 32.8048 33.42C32.8848 33.77 32.7548 34.13 32.5148 34.2L27.0348 35.98C26.8548 36.03 26.6648 35.89 26.5848 35.64ZM40.8148 37.44H28.7048C28.7048 37.44 33.1548 36 33.8648 35.93C38.1648 35.5 40.8148 35.68 40.8148 35.68V37.44Z",
    fill: color
  }));
};

IconRearCrossTrafficWarning.defaultProps = {
  color: 'black'
};
IconRearCrossTrafficWarning.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconRearCrossTrafficWarning;
exports.default = _default;